import './HelpSidebar.css';

export default function HelpSidebar({
  categories,
  articlesById,
  selectedArticleId,
  onSelectArticle,
}) {
  return (
    <nav className="help-sidebar" aria-label="Help categories">
      <div className="help-sidebar-title">Help Center</div>
      {categories.map((category) => (
        <div key={category.id} className="help-sidebar-section">
          <div className="help-sidebar-heading">{category.title}</div>
          <ul className="help-sidebar-list">
            {category.articles.map((articleId) => {
              const article = articlesById[articleId];
              if (!article) return null;
              const isActive = article.id === selectedArticleId;
              return (
                <li key={article.id}>
                  <button
                    type="button"
                    className={`help-sidebar-link${isActive ? ' is-active' : ''}`}
                    onClick={() => onSelectArticle(article.id)}
                  >
                    {article.title}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
